import React from 'react'
import Grid from '@active/react-ui/Grid'
import GridItem from '@active/react-ui/GridItem'
import Link from '@active/react-ui/Link'
import { withI18n } from '@active/react-utils/i18n'
import Responsive from '@active/react-utils/components/Responsive'
import Logo from './logo-active.svg'
import './Footer.scss'
import I18nMessage from '../I18nMessage'

export default withI18n(() => {
  const currentYear = new Date().getFullYear().toString()
  return (
    <div className="passport-ui-component__footer">
      <Responsive eqAbove="md">
        <Grid align="center" justify="center">
          <GridItem span={12} className="passport-footer__links">
            <img src={Logo} alt="Active Logo" />
            <Link
              href="http://www.activenetwork.com/information/terms-of-use.htm"
              rel="noopener noreferrer"
              target="_blank"
            >
              <I18nMessage id="passport.footer.btn.termsOfUse" />
            </Link>
            <Link
              href="http://www.activenetwork.com/information/copyright-policy"
              rel="noopener noreferrer"
              target="_blank"
            >
              <I18nMessage id="passport.footer.btn.copyrightPolicy" />
            </Link>
            <Link
              href="http://www.activenetwork.com/information/privacy-policy.htm"
              rel="noopener noreferrer"
              target="_blank"
            >
              <I18nMessage id="passport.footer.btn.privacyPolicy" />
            </Link>
            <Link
              href="http://activesupport.force.com/usersupport"
              rel="noopener noreferrer"
              target="_blank"
            >
              <I18nMessage id="passport.footer.btn.support" />
            </Link>
            <Link
              href="http://www.activenetwork.com"
              rel="noopener noreferrer"
              target="_blank"
            >
              ©&nbsp;
              {currentYear}
              &nbsp;
              <I18nMessage id="passport.footer.btn.active" />
            </Link>
          </GridItem>
        </Grid>
      </Responsive>
      <Responsive not eqAbove="md">
        <Grid align="center" justify="center" rowGap={15}>
          <GridItem className="passport-footer__logo">
            <img src={Logo} alt="Active Logo" />
          </GridItem>
        </Grid>
        <Grid align="center" justify="center" rowGap={15}>
          <GridItem className="passport-footer__links">
            <Link
              href="http://www.activenetwork.com/information/terms-of-use.htm"
              rel="noopener noreferrer"
              target="_blank"
            >
              <I18nMessage id="passport.footer.btn.mobile_termsOfUse" />
            </Link>
            <Link
              href="http://www.activenetwork.com/information/copyright-policy"
              rel="noopener noreferrer"
              target="_blank"
            >
              <I18nMessage id="passport.footer.btn.mobile_copyrightPolicy" />
            </Link>
            <Link
              href="http://www.activenetwork.com/information/privacy-policy.htm"
              rel="noopener noreferrer"
              target="_blank"
            >
              <I18nMessage id="passport.footer.btn.mobile_privacyPolicy" />
            </Link>
            <Link
              href="http://activesupport.force.com/usersupport"
              rel="noopener noreferrer"
              target="_blank"
            >
              <I18nMessage id="passport.footer.btn.mobile_support" />
            </Link>
          </GridItem>
        </Grid>
        <Grid align="center" justify="center" rowGap={15}>
          <GridItem span={12} className="passport-footer__copyright">
            <Link
              href="http://www.activenetwork.com"
              rel="noopener noreferrer"
              target="_blank"
            >
              ©&nbsp;
              {currentYear}
              &nbsp;
              <I18nMessage id="passport.footer.btn.mobile_active" />
            </Link>
          </GridItem>
        </Grid>
      </Responsive>
    </div>
  )
})
